/**
 * Created by Jerker Nord on 2023-01-18.
 */

export class SpineUtils {

   public static resetSpineAnimation(spineAnimation:PIXI.spine.Spine):void {
      spineAnimation.alpha = 1;
      spineAnimation.updateTransform();
      spineAnimation.state.clearTracks();
      spineAnimation.skeleton.setSlotsToSetupPose();
      spineAnimation.skeleton.setToSetupPose();
   }
}